import { object as yupObject, string as yupString } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import validationMessage from 'util/validations';
import { requiredPhoneNumberWithoutSpaces, requiredWithoutSpaces } from 'util/regex.utils';

export const styles = {
    PROFILE: {
        controlPadding: { },
        typeWidth: {
            width: '100%'
        },
        numberWidth: {
            width: '100%'
        },
        labelStyles: { }
    },
    ONBOARDING: {
        controlPadding: {
            style: {
                padding: '10px 12px 8px 12px'
            }
        },
        typeWidth: {
            width: '44%'
        },
        numberWidth: {
            width: '50%'
        },
        labelStyles: {
            fontSize: '14px'
        }
    }
}

export type IPhoneFormInputs = {
    isPrimary: boolean;
    countryCode: string;
    extension: string;
    number: string;
    type: string;
    asset_id?: string;
    createDate?: string
};

export const formDefaults = {
    isPrimary: false,
    countryCode: '',
    extension: '',
    number: '',
    type: '',
    asset_id: '',
};

const schema = yupObject({
    countryCode: yupString().max(255, validationMessage.max(255)),
    extension: yupString().max(255, validationMessage.max(255)),
    number: yupString().matches(requiredPhoneNumberWithoutSpaces(),validationMessage.required).max(255, validationMessage.max(255)).required(validationMessage.required),
    type: yupString().required(validationMessage.required),
    otherType: yupString()
        .when('type', {
            is: '__other__',
            then: yupString().matches(requiredWithoutSpaces(),validationMessage.required).max(255, validationMessage.max(255)).required(validationMessage.required)
        })
});

export const formSchemaResolver = yupResolver(schema);